import { IDomaine } from "../../cdsApiSlice";
import { DomaineState } from "../DomaineState";
import styles from "./domaineManagement.module.scss";
interface IDomaineIndicator {
    domaine:IDomaine
}

const DomaineIndictor = ({domaine}:IDomaineIndicator) => {
    return(
        <>
        <div className="flex flex-wrap">
            <div className={`${styles.indicatorTitle} mr-1`}>Zone</div>
            <div className="mr-3 font-bold">{domaine.zone}</div>
            <div className={`${styles.indicatorTitle} mr-1`}>Nombre de sources</div>
            <div className="font-bold mr-1">{domaine.sourcesCount}</div>
            <div className="ml-2"><DomaineState domaineName={domaine.libelle} nifiStatus={domaine.statutNifi}></DomaineState></div>
        </div>
        </>
    )
}


export default DomaineIndictor